import fetchMock from "fetch-mock";

export const delay = () => new Promise((res, rej) => setTimeout(res, 500));

export function futureCalls(url_matcher: string, method: string | null = null) {
    let matchOptions =  method ? { method } : undefined
    return () =>
        fetchMock.calls(url_matcher, matchOptions).map( call => {
            const callOptions: any = call[1]
            if (callOptions) {
                return {
                    body: callOptions.body ? JSON.parse(callOptions.body) : null
                }
            } else return {
                body: null
            }
        })
}
